<!--
  金额面板
  lovi 2020-07-02
 -->
<template>
  <div class="money-list">
    <ul :class="{ moreMoney: moreFlag }">
      <li
        :class="{ active: moneyId == item.denomination_id }"
        v-for="(item, index) in list"
        :key="index"
        @click="chooseMoney(item.amount, item.denomination_id)"
      >
        <h3>{{ item.amount }}P</h3>
        <p v-if="rate">
          {{ $t("common.price") }}
          {{ _PHPtoRMB(Number(item.amount), rate) }}
          {{ $t("common.CNY") }}
        </p>
      </li>
    </ul>
    <div class="more" v-if="list.length > 6">
      <span @click="moreFlag = !moreFlag">
        {{ $t("common.moreDenomination") }}
        <van-icon :class="{ rotate: moreFlag }" name="arrow-down" />
      </span>
    </div>
    <van-field
      class="van-field-input"
      type="number"
      v-if="custom.amount_mini"
      v-model="amount"
      :formatter="_formatter"
      :placeholder="
        $t('common.customized') + custom.amount_mini + '-' + custom.amount_max
      "
      @input="inputAmount"
    >
      <span slot="right-icon">P</span>
    </van-field>
    <a class="recently" @click="clickRecently">
      {{ $t("common.recentChargeAmount") }}
      {{ Number(recently).toFixed(2) }}P,
      {{ $t("common.clickContinueRecharge") }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      // 金额列表
      type: Array,
      default: function() {
        return [];
      }
    },
    rate: {
      //汇率
      type: Number,
      default: function() {
        return 0;
      }
    },
    custom: {
      //自定义信息
      type: Object,
      default: function() {
        return {};
      }
    },
    money: {
      //金额
      type: Number,
      default: function() {
        return 0;
      }
    },
    moneyId: {
      //金额Id
      type: Number,
      default: function() {
        return 0;
      }
    },
    recently: {
      //最近充值
      type: String,
      default: function() {
        return "";
      }
    }
  },
  components: {},
  data() {
    return {
      moreFlag: false,
      amount: "", //输入金额
      id: "" //金额Id
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    chooseMoney(money, id) {
      //选择金额
      let vm = this;
      vm.amount = Number(money);
      vm.id = Number(id);
      vm.$emit("update:money", vm.amount);
      vm.$emit("update:moneyId", vm.id);
    },
    inputAmount() {
      //输入金额
      let vm = this;
      vm.$emit("update:money", Number(vm.amount));
      console.log("money", Number(vm.amount));
      vm.$emit("update:moneyId", 0);
    },
    clickRecently() {
      //点击最近充值
      let vm = this;
      vm.amount = Number(vm.recently);
      vm.$emit("update:money", vm.amount);
      for (let key of vm.list) {
        if (vm.amount == key.amount) {
          vm.id = key.denomination_id;
          vm.$emit("update:moneyId", vm.id);
          return false;
        } else {
          vm.id = 0;
          vm.$emit("update:moneyId", 0);
        }
      }
    },
    _getDefaultMoney(arr) {
      // 获取默认金额
      let vm = this;
      for (let i = 0; i < arr.length; i++) {
        if (vm.money || vm.moneyId) {
          vm.amount = vm.money;
          vm.id = vm.moneyId;
          return false;
        }
        if (arr[i].default) {
          vm.amount = Number(arr[i].amount);
          vm.id = Number(arr[i].denomination_id);
          vm.$emit("update:money", vm.amount);
          vm.$emit("update:moneyId", vm.id);
        }
      }
    }
  },
  watch: {
    list: {
      handler(arr) {
        if (arr.length) {
          console.log("handler");
          this._getDefaultMoney(arr);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.money-list {
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 5px 0 5px -8px;
    width: calc(100% + 8px);
    max-height: 132px;
    overflow: hidden;
    &.moreMoney {
      max-height: initial;
    }
    li {
      display: flex;
      justify-content: center;
      flex-flow: column;
      margin: 5px 0 5px 8px;
      width: calc(33.3333% - 8px);
      text-align: center;
      height: 54px;
      line-height: 1;
      color: #9b9b9b;
      background: #fff;
      border: 1.1px solid #ccc;
      border-radius: 5px;
      &.active {
        color: #fff;
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
        border-color: rgba(32, 67, 172, 1);
      }
      h3 {
        font-weight: 400;
      }
      p {
        margin-top: 4px;
        font-size: 10px;
        // transform: scale(0.9)
      }
    }
  }
  .more {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/.van-icon {
        margin-left: 2px;
        font-size: 14px;
        transition: transform 0.5s;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .recently {
    display: block;
    text-align: right;
    color: #2042ab;
    font-size: 0.26667rem;
    margin-top: 0.16rem;
  }
}
</style>
